


















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Dialog } from 'vant';
import * as config from '../config';
Vue.use(Dialog);
@Component({
  components: {},
})
export default class ListItem extends Vue {
  option = config.OPTHINES;
  @Prop() item!: any;
  @Prop({ default: true }) showVotes!: any;

  name = '';
  school = '';
  class = '';

  get GradeData() {
    for (const index of Object.keys(this.option.Grades)) {
      let res = '';
      if (Number(index) === this.item.grade - 1) {
        res = this.option.Grades[Number(index)];
        return res;
      }
    }
  }
  get createtime() {
    const date = new Date(this.item.created_at * 1000);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const d = date.getDate();
    return year + '-' + month + '-' + d;
  }
  enterDetail(item: any) {
    if (item.status === 2) {
      Dialog({ message: '未审核通过，请上传符合要求的作品' });
    } else {
      this.$router.push({
        path: './Detail',
        query: { id: item.id },
      });
    }
  }
}
